import { render, staticRenderFns } from "./UnSubscribed.vue?vue&type=template&id=0dec4497&scoped=true&"
import script from "./UnSubscribed.vue?vue&type=script&lang=js&"
export * from "./UnSubscribed.vue?vue&type=script&lang=js&"
import style0 from "./UnSubscribed.vue?vue&type=style&index=0&id=0dec4497&scoped=true&lang=css&"
import style1 from "./UnSubscribed.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dec4497",
  null
  
)

export default component.exports